import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import NavBar from '../components/NavBar'
import FrTextInput from '../components/FrTextInput'
import FrSelect from '../components/FrSelect'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'
import { mCPF, mCEP, mTel, mCNPJ, mVAL } from '../utils/masks'
import { colors } from '../utils/vars'
import FrDatePicker from '../components/FrDatePicker'
import FrRadioButton from '../components/FrRadioButton'

import api from '../services/api'
import { paramsToObject, getUserCode } from '../utils/functions'

import './styles/DefaultReg.css';
import FooterDelphus from '../components/FooterDelphus';


const swal = withReactContent(Swal)

function Clientes(props) {
  const [data, setData] = useState({ })
  const [updateType, setUpdateType] = useState(false)
  const [enableEdit, setEnableEdit] = useState('N')
  const [comboPlc, setComboPlc] = useState([{ value: '', display: '' }])
  const [comboFpg, setComboFpg] = useState([{ value: '', display: '' }])
  const [comboSede, setComboSede] = useState([{ value: '', display: '' }])
  const [invalido, setInvalido] = useState(false)
  const [fk_tlc, setFk_tlc] = useState("1")
  const [disableEdit, setdisableEdit] = useState(false)

  useEffect(() => {
    const fetchData = async () => {
      swal.fire({
        customClass: {
          container: 'my-swal'
        },

        html: <FrLoading text="Carregando..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)
      let codigo = props.pk_lan ? props.pk_lan : query.codigo
      setComboFpg(await api.getComboData('formas_pagamento'))
      setComboSede(await api.getComboData('sedes'))

      if (codigo > 0) {
        setEnableEdit(await api.getAcessos('lancamentos', 'Alteracao'))
      } else {
        setEnableEdit(await api.getAcessos('lancamentos', 'Inclusao'))
      }


      if (codigo > 0) {
        setUpdateType(true)
        api.get('/lancamentos?pk_lan=' + codigo).then(async r => {
          if (r.data[0]) {
            let auxValues = { ...r.data[0] }
            setFk_tlc(String(auxValues.fk_tpc))
            console.log(auxValues.valor)
            auxValues.valor = mVAL(Math.round(auxValues.valor * 100 * 100) / 100)
            setData(auxValues)
            swal.close()
          } else {
            swal.fire({
              customClass: {
                container: 'my-swal'
              },
              title: `<h2 style='color: ${colors.info900}'>Código inválido</h2>`,
              html: `<p style='color: ${colors.info900}'>Código informado não encontrado!</p>`,
              icon: 'warning',
            }).then((result) => {
              if (result.value) {
                if (props.modal)
                  props.setShowModal(false)
                else
                  window.history.back()
              }
            })
          }
        })
      } else swal.close()
    }

    fetchData()
  }, [])

  useEffect(() => {

    async function fetchComboData() {
      let data = await api.getComboDataWhere('plano_contas', '?fk_tlc=' + fk_tlc)
      setComboPlc(data)
    }

    fetchComboData()
  }, [fk_tlc])

  function consistData(data) {
    let required = [
      
    ]

    let errors = []

    required.forEach((curr, index) => {
      let fieldName = curr
      if ((!data[curr]) && (fieldName !== '')) return errors.push(fieldName)
    })

    return errors
  }


  function handleSubmit(e) {
    e.preventDefault();

    swal.fire({
      customClass: {
        container: 'my-swal'
      },

      title: `<h2 style='color:${colors.info900}'>ATENÇÃO</h2>`,
      html: `<p style='color:${colors.info900}'>Deseja salvar ${updateType ? 'as alterações' : 'a inclusão'} do registro?</p>`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: colors.success500,
      cancelButtonColor: colors.danger500,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        const auxValues = { ...data };
        auxValues.fk_usu = getUserCode()
        console.log(auxValues.valor)
        auxValues.valor = auxValues.valor.replaceAll('.','').replace(',','.')
        console.log(auxValues.valor)
        auxValues.fk_cta = props.fk_cta
        auxValues.data = auxValues.data.split('T')[0]
        let errors = consistData(auxValues, e)
        if (errors.length === 0) {
          if (updateType) {
            api.post('/lancamentos/edit', auxValues).then(r => {
              if (r.status === 200) {
                swal.fire({
                  customClass: {
                    container: 'my-swal'
                  },

                  title: `<h2 style='color: ${colors.info900}'>Registro Alterado<h2>`,
                  html: `<p style='color: ${colors.info900}'>O registro foi alterado com sucesso!</p>`,
                  icon: 'success',
                }).then((result) => {
                  if (result) {
                    if (props.modal) {
                      props.setShowModal(false)
                      props.buscaDados && props.buscaDados()
                    } else
                      window.history.back()
                  }
                })
              } else {
                swal.fire({
                  customClass: {
                    container: 'my-swal'
                  },

                  title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
                  html: `<p style='color: ${colors.info900}'></p>`,
                  icon: 'warning',
                })
              }
            })
          } else {
            try {
              api.post('/lancamentos/add', auxValues).then(r => {
                if (r.status === 200) {
                  let cliente = r.data
                  swal.fire({
                    customClass: {
                      container: 'my-swal'
                    },

                    title: `<p style='color:${colors.info900}'Registro Adicionado</p>`,
                    html: `<p style='color: ${colors.info900}'>O registro foi adicionado com sucesso!</p>`,
                    icon: 'success',
                  }).then((result) => {
                    if (result) {
                      props.setPk_lan(r.data.insertId)
                      props.setShowModal(false)
                      props.buscaDados && props.buscaDados()
                    }
                  })


                } else {
                  swal.fire({
                    customClass: {
                      container: 'my-swal'
                    },

                    title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
                    text: "O registro não foi adicionado!",
                    icon: 'warning',
                  })
                }
              })
            } catch {
              swal.fire({
                customClass: {
                  container: 'my-swal'
                },

                title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
                text: "O registro não foi adicionado!",
                icon: 'warning',
              })

            }

          }
        } else {
          if (errors.length > 0) {
            swal.fire({
              customClass: {
                container: 'my-swal'
              },

              title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
              html: <p style={{ color: colors.info900 }}>Verifique {errors.length > 1 ? 'os campos' : 'o campo'} {errors.join(', ')}</p>,
              icon: 'warning',
            })

          } else if (invalido) {
            swal.fire({
              customClass: {
                container: 'my-swal'
              },

              title: `<h2 style='color: ${colors.info900}'>Documento inválido!</h2>`,
              html: <p style={{ color: colors.info900 }}>Verifique o CPF/CNPJ</p>,
              icon: 'warning',
            })
          }
        }
      }
    })
  }

  function handleCancel(e) {
    e.preventDefault();
    swal.fire({
      customClass: {
        container: 'my-swal'
      },

      title: `<h2 style='color:${colors.info900}'>ATENÇÃO</h2>`,
      html: `<p style='color: ${colors.info900}'>Caso cancele a alteração/inclusão, todos os dados digitados serão perdidos. Confirma?<p>`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: colors.success500,
      cancelButtonColor: colors.danger500,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result) {
        if (props.modal)
          props.setShowModal(false)
        else
          window.history.back()
      }
    })
  }

  const handleChange = (e) => {
    const auxValues = { ...data };
    switch (e.target.name) {
      
      case 'valor': auxValues[e.target.name] = mVAL(e.target.value);
      break;

      default: auxValues[e.target.name] = e.target.value.toUpperCase();

    }
    console.log(e.target.name, e.target.value, auxValues.valor, data.valor)
    setData(auxValues);
  };

 


  return (
    <div className="defaultReg">
      {!props.modal ? <NavBar /> : <></>}
      <div className="defaultRegContent">
        <div className="defaultHeader">
          <h3>{updateType ? 'Edição' : 'Inclusão'} de Lançamento</h3>
           

          {!props.modal ? <UserOptions temaEscuro={props.temaEscuro} setTemaEscuro={props.setTemaEscuro} /> : <></>}
        </div>
        <br />

        <form id="regForm" onSubmit={handleSubmit}>
          <FrDatePicker
            name="data"
            id="data"
            color="#389492"
            label="Data"
            variant="outlined"
            size="small"
            style={{ width: 180 }}
            value={(data.data || '').split("T")[0]}
            onChange={handleChange}
          />

          <FrTextInput
            value={mVAL(data.valor) || ''}
            onChange={handleChange}
            name="valor"
            id="valor"
            color="#389492"
            label={"Valor"}
            variant="outlined"
            size="small"
            required
            style={{ width: 120 }}
          />

          <br/>

          <FrTextInput
            maxLength='100'
            value={data.descricao || ''}
            onChange={handleChange}
            name="descricao"
            id="descricao"
            color="#389492"
            label={"Descrição"}
            variant="outlined"
            size="small"
            required
            style={{ width: 420 }}
          />                    

          

          <div>
          <FrSelect
            value={data.fk_plc || ''}
            onChange={handleChange}
            name="fk_plc"
            id="fk_plc"
            label='Plano de Contas'
            data={comboPlc}
            style={{ width: 220 }}
          />
            <FrRadioButton 
              value={fk_tlc}
              id='tipo_conta_plano'
              name='tipo_conta_plano'
              row
              onChange={(e) => {
                setFk_tlc(e.target.value)
              }}
              data={[{display: 'Receita', value: "1"}, {display: 'Despesa', value: "2"}]}
            />
          </div>

          <br/>

          <FrSelect
            value={data.fk_fpg || ''}
            onChange={handleChange}
            name="fk_fpg"
            id="fk_fpg"
            label='Forma de Pagamento'
            data={comboFpg}
            style={{ width: 220 }}
          />
          <FrSelect
            value={data.fk_sed || ''}
            onChange={handleChange}
            name="fk_sed"
            id="fk_sed"
            label='Sede'
            data={comboSede}
            style={{ width: 180 }}
          />

        </form>
        <div className="regButtonsDiv">
          
          <button onClick={handleSubmit}>Salvar</button>
          <button onClick={handleCancel}>Cancelar</button>
        </div>
        {!props.modal ? <FooterDelphus /> : <></>}
      </div>
    </div>
  );
}

export default Clientes;
